// @file Idle state for the EraserTool
// Original file: https://github.com/tldraw/tldraw/blob/main/packages/tldraw/src/lib/tools/EraserTool/childStates/Idle.ts
import type { TLEventHandlers } from '@tldraw/editor'
import { StateNode } from '@tldraw/editor'

export class Idle extends StateNode {
  static override id = 'idle'

  override onPointerDown: TLEventHandlers['onPointerDown'] = (info) => {
    this.parent.transition('pointing', info)
  }

  override onCancel = (): void => {
    this.editor.setCurrentTool('select')
  }
}
